import { render } from "./Modal.vue?vue&type=template&id=18bc8e81&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=18bc8e81&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bc8e81"],['__file',"resources/js/Shared/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18bc8e81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18bc8e81', __exports__)) {
    console.log('reload')
    api.reload('18bc8e81', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=18bc8e81&scoped=true", () => {
    console.log('re-render')
    api.rerender('18bc8e81', render)
  })

}


export default __exports__